<template>
	<div>
		<!-- 顶部 -->
		<div class="header-body">
			<Button type="info" @click="add">添加</Button>
		</div>
		<Divider />
		<!-- table -->
		<Table :columns="columns" :data="data" border></Table>
		<!-- 分页 -->
		<div class="page-body">
			<Page :total="total" :current='page' @on-change="changePage" show-elevator show-total/>
		</div>
		
		<!-- 头像 -->
		<Modal v-model="addShow" :title="addTitle" width="600" :mask-closable="false">
			<Form ref="formData" :model="formData" :label-width="80">
				<FormItem label="类型">
					<Select v-model="formData.type" placeholder="请选择轮播类型" style="width: 200px;">
						<Option value="1">诗词</Option>
						<Option value="2">朝代</Option>
						<Option value="3">旅游</Option>
					</Select>
				</FormItem>
				<FormItem label="图片">
					<Uploads v-if="addShow" :images="formData.src" @send-img="getImg"></Uploads>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="default" @click="addShow = false;">取消</Button>
				<Button type="primary" @click="submit">提交</Button>
			</div>
		</Modal>
	</div>
</template>
	
<script>
	import Uploads from '@/components/Uploads'
	import { getShuf, addShuf, editShuf,deleteShuf } from '@/utils/wenxue.js'
	export default {
		name: 'Shuf',
		components: {
			Uploads
		},
		data() {
			return {
				page:1,
				total:0,
				data: [],
				columns: [
					{
						title:'序号',
						width:80,
						align:'center',
						render:(h,param)=>{
							return h('span',{},param.index - 0 + 1)
						}
					},
					{
						title: '图标',
						minWidth: 150,
						align: 'center',
						render:(h,param)=>{
							return h('img',{
								attrs:{
									src:param.row.src
								},
								style:{
									width:'58px',
									height:'58px'
								}
							})
						}
					},
					{
						title:'类型',
						width:120,
						align:'center',
						key:'type_text'
					},
					{
						title: '操作',
						minWidth: 150,
						align: 'center',
						render: (h, param) => {
							var _that = this;
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '6px'
									},
									on: {
										'click': function() {
											_that.addShow = true;
											_that.addTitle = '编辑图片';
											
											_that.formData.id = param.row.id;
											_that.formData.type = param.row.type.toString();
											_that.formData.src = param.row.src ? [param.row.src] : [];
										}
									}
								}, '编辑'),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {

									},
									on: {
										'click': function() {
											_that.$Modal.confirm({
												title: '删除确认',
												content: '该操作不可逆，是否确认删除？',
												onOk: function() {
													deleteShuf({
														id: param.row.id
													}).then(res => {
														let index = null;
														_that.data.forEach((e, key) => {
															if(e.id == res) {
																index = key;
															}
														})

														if(index !== null) _that.data.splice(index, 1);
													})
												}
											})
										}
									}
								}, '删除')
							])
						}
					}
				],
				addShow: false,
				addTitle:'添加图片',
				formData: {
					id:0,
					src:[],
					type:1
				},
			}
		},
		methods: {
			changePage(page){
				this.getList(page);
			},
			async getList(page) {
				this.page = page;
				const param = {
					page:page || 1,
					page_num:10
				};
				
				const data = await getShuf({form:param});

				this.data = data['data'];
				this.total = data['total'];
			},
			add() {
				this.addShow = true;
				this.addTitle = '添加图片';
				
				this.formData.id = 0;
				this.formData.src = [];
				this.formData.type = '1';
			},
			getImg(img) {
				this.formData.src = img;
			},
			submit() {
				if(this.formData.src.length == 0){
					this.$Message.warning('请上传图片');
					
					return false;
				}
				
				var _that = this;
				const param = {
					src:this.formData.src[0],
					type:this.formData.type
				};
				
				if(_that.formData.id > 0){
					param.id = _that.formData.id;
					editShuf({
						form: param
					}).then((res) => {
						_that.$Message.info('添加成功');
						_that.addShow = false;
						_that.getList(_that.page);
					})
				}else{
					addShuf({
						form: param
					}).then((res) => {
						_that.$Message.info('添加成功');
						_that.addShow = false;
						_that.getList();
					})
				}
			},
		},
		mounted() {
			this.getList();
		}
	}
</script>

<style scoped>
	.ivu-layout {
		height: 100vh !important;
	}
	
	.header-body {
		width: 100%;
		min-height: 36px;
		display: flex;
		align-items: center;
	}
	
	.ivu-divider-horizontal {
		margin: 12px !important;
	}
	.page-body{
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/views/wenxue/Shuf.vue